<template>
    <KFormDisplay
        v-if="operationsanmalan"
        ref="formDisplay"
        class="operationsinformation"
        config-module-name="operation"
        config-sub-module-name="OPERATION_ANMALAN"
        :showEmptyValues="false"
        formPadding="sections"
    >
        <template #header>
            <h1>Operationsinformation</h1>
            <AnmalanInfoBar v-if="isNonEmptyObject(operationsanmalan)" :anmalan="operationsanmalan" />
        </template>
        <template #default>
            <KSection name="allmaninformation" :collapsible="false" :numbered="false">
                <div class="form-content">
                    <KFormFieldDisplay
                        name="bokad_operation_datum"
                        label="Bokat operationsdatum"
                        validation="required"
                        :value="operationsanmalan.bokad_operation_datum"
                    />
                    <KFormFieldDisplay
                        name="bokad_operation_tid"
                        label="Bokad operationstid"
                        :value="operationsanmalan.bokad_operation_tid?.substr?.(0, 5)"
                    />
                    <KFormFieldDisplay
                        name="bokad_sal"
                        label="Bokad sal"
                        :value="operationsanmalan.bokad_sal_display?.namn"
                    />
                </div>
                <div class="form-content">
                    <KFormFieldDisplay
                        name="kontaktorsak"
                        label="Kontaktorsak"
                        validation="required"
                        :value="operationsanmalan.kontaktorsak_display?.displayName"
                    />
                    <KFormFieldDisplay
                        name="typoperation"
                        label="Typoperation"
                        class="span-two"
                        :value="operationsanmalan.typoperation_display?.namn"
                    />
                    <KFormFieldDisplay
                        name="documentTime"
                        label="Dokumentationsdatum"
                        validation="required"
                        :value="operationsanmalan.documentTime?.split('T')[0]"
                    />
                </div>
            </KSection>
            <KSection name="planering" class="planering" heading="Planering">
                <div class="form-content">
                    <div class="form-section span-four">
                        <KFormFieldDisplay
                            name="operationsenhet"
                            label="Operationsenhet"
                            validation="required"
                            :value="operationsanmalan.operationsenhet_display?.name"
                        />
                        <KFormFieldDisplay
                            name="huvudoperator"
                            label="Huvudoperatör"
                            validation="required"
                            showEmptyValue
                            :value="
                                operationsanmalan.current_bokad_huvudoperator_ej_bestamd
                                    ? 'Ej bestämd'
                                    : operationsanmalan.current_bokad_huvudoperator_display?.user_display?.name
                            "
                        />
                        <KFormFieldDisplay
                            name="kort_varsel"
                            label="Kort varsel"
                            :value="operationsanmalan.kort_varsel"
                        />
                        <KFormFieldDisplay
                            name="ass_operatorer"
                            label="Assisterande operatörer"
                            :value="operationsanmalan.ass_operatorer_display"
                            content-direction="vertical"
                            #default="{ value }"
                        >
                            <span v-for="item in value" :key="item.id">
                                {{ item.user_display.name }}
                            </span>
                        </KFormFieldDisplay>
                        <KFormFieldDisplay
                            v-if="!!operationsanmalan.assoperator_ej_bestamd"
                            name="assoperator_ej_bestamd"
                            label="Assisterande operatör ej bestämd"
                            :value="operationsanmalan.assoperator_ej_bestamd"
                        >
                            <span> Ej bestämd </span>
                        </KFormFieldDisplay>
                        <KFormFieldDisplay
                            name="prio"
                            label="Prioritet"
                            :value="operationsanmalan.prio_display?.displayName"
                        />

                        <KFormFieldDisplay
                            name="preliminart_datum"
                            label="Önskat operationsdatum"
                            :value="operationsanmalan.preliminart_datum"
                        />
                        <KFormFieldDisplay
                            name="avtal"
                            label="Avtal"
                            validation="required"
                            :value="operationsanmalan.avtal_display?.namn"
                        />
                        <KFormFieldDisplay
                            name="forsakringsbolag"
                            label="Försäkringsbolag"
                            :value="operationsanmalan.forsakringsbolag_display?.namn"
                        />
                        <KFormFieldDisplay
                            name="planerad_vardform"
                            label="Planerad vårdform"
                            validation="required"
                            :value="operationsanmalan.planerad_vardform_display?.namn"
                        />
                        <KFormFieldDisplay
                            name="inlaggning_antal_dagar_fore"
                            label="Inläggning antal dygn före op"
                            :value="operationsanmalan.inlaggning_antal_dagar_fore"
                        />
                        <KFormFieldDisplay
                            name="antal_dagar_pa_avdelning"
                            label="Totalt antal dygn på avdelningen"
                            class="span-two"
                            :value="operationsanmalan.antal_dagar_pa_avdelning"
                        />
                        <KFormFieldDisplay
                            name="info_till_vardavdelningen"
                            label="Info till vårdavdelningen"
                            class="span-two"
                            :value="operationsanmalan.info_till_vardavdelningen"
                        />
                    </div>
                </div>
            </KSection>

            <KSection name="operation" class="operation" heading="Operation">
                <div class="form-content">
                    <div class="form-section span-all">
                        <KFormFieldDisplay
                            name="huvudiagnos"
                            label="Huvuddiagnos"
                            validation="required"
                            class="span-all"
                            :value="
                                operationsanmalan?.huvuddiagnos_display?.code &&
                                operationsanmalan?.huvuddiagnos_display?.displayName
                                    ? `${operationsanmalan.huvuddiagnos_display.code} ${operationsanmalan.huvuddiagnos_display.displayName}`
                                    : undefined
                            "
                        />
                        <KFormFieldDisplay
                            name="bidiagnos"
                            label="Bidiagnos"
                            class="span-all"
                            :value="operationsanmalan?.bidiagnoser_display"
                            content-direction="vertical"
                            #default="{ value, emptyValue }"
                        >
                            <span v-for="(item, index) in value" :key="index">
                                {{ item.code && item.displayName ? `${item.code} ${item.displayName}` : emptyValue }}
                            </span>
                        </KFormFieldDisplay>
                        <KFormFieldDisplay
                            name="huvudoperationskod"
                            label="Huvudoperationskod"
                            validation="required"
                            class="span-all"
                            content-direction="vertical"
                            :value="
                                operationsanmalan?.huvudoperationskod_display?.code &&
                                operationsanmalan?.huvudoperationskod_display?.displayName
                                    ? `${operationsanmalan.huvudoperationskod_display.code} ${operationsanmalan.huvudoperationskod_display.displayName}`
                                    : undefined
                            "
                        />
                        <KFormFieldDisplay
                            name="bioperationskoder"
                            label="Bioperationskoder"
                            class="span-all"
                            :value="operationsanmalan?.bioperationskoder_display"
                            content-direction="vertical"
                            #default="{ value, emptyValue }"
                        >
                            <span v-for="(item, index) in value" :key="index">
                                {{ item.code && item.displayName ? `${item.code} ${item.displayName}` : emptyValue }}
                            </span>
                        </KFormFieldDisplay>
                    </div>
                    <KFormFieldDisplay name="garantiop" label="Garantioperation" :value="operationsanmalan.garantiop" />
                    <KFormFieldDisplay name="reop" label="Reoperation" :value="operationsanmalan.reop" />

                    <KFormFieldDisplay
                        name="niva_fran_till"
                        label="Nivå från - till"
                        :value="operationsanmalan.niva_fran_till_display"
                        content-direction="vertical"
                    >
                        <NivaFranTill :data="operationsanmalan.niva_fran_till_display" />
                    </KFormFieldDisplay>
                    <KFormFieldDisplay
                        name="nivaer"
                        label="Nivåer"
                        :value="calculateAntalNivaer(operationsanmalan.niva_fran_till_display)"
                    />
                    <KFormFieldDisplay
                        name="digitum"
                        label="Digitum/Digitus"
                        :value="operationsanmalan.digitum_display"
                        content-direction="vertical"
                    />

                    <KFormFieldDisplay
                        name="forberedelser"
                        label="Förberedelsetid (min)"
                        validation="required"
                        :value="operationsanmalan.forberedelser"
                    />
                    <KFormFieldDisplay
                        name="optid"
                        label="Operationstid (min)"
                        validation="required"
                        :value="operationsanmalan.optid"
                    />
                    <KFormFieldDisplay
                        name="avveckling"
                        label="Avvecklingstid (min)"
                        validation="required"
                        :value="operationsanmalan.avveckling"
                    />
                    <KFormFieldDisplay
                        name="oplage"
                        label="Patientläge"
                        validation="required"
                        :value="operationsanmalan.oplage_display?.displayName"
                    />
                    <KFormFieldDisplay
                        name="lateralitet"
                        label="Sida"
                        validation="required"
                        :value="operationsanmalan.lateralitet_display"
                    />
                    <KFormFieldDisplay
                        name="anestesi"
                        label="Anestesi"
                        validation="required"
                        :value="operationsanmalan.anestesi_display?.displayName"
                    />
                    <KFormFieldDisplay
                        name="blockad"
                        label="Blockad"
                        validation="required"
                        :value="operationsanmalan.blockad_display?.displayName"
                    />
                    <KFormFieldDisplay
                        name="resurser"
                        label="Resurser"
                        class="resurser span-all"
                        :value="operationsanmalan.resurser_display"
                        content-direction="vertical"
                        #default="{ value }"
                    >
                        <span v-for="(item, index) in value" :key="index">
                            {{ getResursWithStatus(item) }}
                        </span>
                    </KFormFieldDisplay>
                    <KFormFieldDisplay
                        name="implantat"
                        label="Implantat"
                        class="span-all"
                        :value="operationsanmalan.implantat_display"
                        content-direction="vertical"
                        #default="{ value }"
                    >
                        <span v-for="(item, index) in value" :key="index">
                            {{ item.namn }}
                        </span>
                    </KFormFieldDisplay>
                    <KFormFieldDisplay
                        name="studie_kvalitetsregister"
                        label="Studie/Kvalitetsregister"
                        class="span-two"
                        :value="operationsanmalan.studie_kvalitetsregister_display"
                        content-direction="vertical"
                        #default="{ value }"
                    >
                        <span v-for="item in value" :key="item.id">
                            {{ item.namn }}
                        </span>
                    </KFormFieldDisplay>
                    <KFormFieldDisplay
                        name="operationsinformation"
                        label="Operationsinformation"
                        class="span-two"
                        :value="operationsanmalan.operationsinformation"
                    />
                    <KFormFieldDisplay
                        name="anestesibedomning_via"
                        label="Preanestesibedömning via"
                        :value="operationsanmalan.anestesibedomning_via_display?.displayName"
                    />
                </div>
            </KSection>

            <KSection name="patientinformation" class="patientinformation" heading="Patientinformation">
                <div class="form-content">
                    <KFormFieldDisplay name="rokare" label="Rökare" :value="operationsanmalan.rokare_display" />
                    <KFormFieldDisplay
                        name="rokare"
                        label="Rökavvänjning har erbjudits"
                        :value="operationsanmalan.rokavvanjning_display"
                    />

                    <KFormFieldDisplay name="tolk" label="Tolk" :value="operationsanmalan.tolk_display" />
                    <KFormFieldDisplay
                        name="sprak"
                        label="Språk"
                        validation="required"
                        :value="operationsanmalan.sprak_display"
                    />

                    <KFormFieldDisplay
                        name="snus_och_andra_nikotinpreparat"
                        label="Snus och andra nikotinpreparat"
                        :value="operationsanmalan.snus_och_andra_nikotinpreparat_display"
                    />

                    <KFormFieldDisplay name="langd" label="Längd (cm)" :value="operationsanmalan.langd" />
                    <KFormFieldDisplay
                        name="vikt"
                        label="Vikt kg"
                        :value="replaceSeparator({ value: operationsanmalan.vikt })"
                    />
                    <KFormFieldDisplay name="bmi" label="BMI" :value="bmi()" />
                    <KFormFieldDisplay name="invagning" label="Invägning" :value="operationsanmalan.invagning" />
                    <KFormFieldDisplay
                        name="viktminskning"
                        label="Önskad viktminskning (kg)"
                        :value="replaceSeparator({ value: operationsanmalan.viktminskning })"
                    />
                    <KFormFieldDisplay name="diabetes" label="Diabetes" :value="operationsanmalan.diabetes" />
                    <KFormFieldDisplay
                        name="diabetes_lakemedelsform"
                        label="Behandlingsform för Diabetes"
                        validation="required"
                        :value="typeof diabetes_lakemedelsform === 'string' ? diabetes_lakemedelsform : undefined"
                    />
                    <KFormFieldDisplay
                        name="funktionsbedomning"
                        label="Bedömd ASA-klass"
                        :value="
                            typeof operationsanmalan.funktionsbedomning === 'string'
                                ? operationsanmalan.funktionsbedomning
                                : undefined
                        "
                    />
                    <KFormFieldDisplay
                        name="giltig_halsodeklaration"
                        label="Giltig hälsodeklaration"
                        :value="
                            typeof operationsanmalan.giltig_halsodeklaration_display === 'string'
                                ? operationsanmalan.giltig_halsodeklaration_display
                                : undefined
                        "
                    />
                    <KFormFieldDisplay
                        name="blodtryck_systoliskt"
                        label="Blodtryck syst"
                        :value="operationsanmalan.blodtryck_systoliskt"
                    />
                    <KFormFieldDisplay
                        name="blodtryck_diastoliskt"
                        label="Blodtryck diast"
                        :value="operationsanmalan.blodtryck_diastoliskt"
                    />
                    <KFormFieldDisplay
                        name="blodsmitta"
                        label="Blodsmitta"
                        :value="operationsanmalan.blodsmitta_display"
                    />
                    <KFormFieldDisplay
                        name="multiresistenta_bakterier"
                        label="Multiresistenta bakterier"
                        :value="operationsanmalan.multiresistenta_bakterier_display"
                    />
                </div>
            </KSection>

            <KSection
                name="operationsforberedande_atgarder"
                class="operationsforberedande_atgarder"
                heading="Operationsförberedande åtgärder"
            >
                <div class="form-content">
                    <KFormFieldDisplay
                        name="trombolysprofylax"
                        label="Trombolysprofylax"
                        :value="operationsanmalan.trombosprofylax_display?.displayName"
                    />
                    <KFormFieldDisplay
                        name="antibiotikaprofylax"
                        label="Antibiotikaprofylax"
                        :value="operationsanmalan.antibiotikaprofylax_display?.displayName"
                    />
                    <KFormFieldDisplay
                        name="antikoagulantia"
                        label="Antikoagulantia sedan tidigare"
                        :value="operationsanmalan.antikoagulantia_display"
                    />
                    <KFormFieldDisplay
                        name="satts_ut_dagar_innan"
                        label="Sätts ut dagar för op"
                        :value="operationsanmalan.satts_ut_dagar_innan"
                    />
                    <KFormFieldDisplay name="nsaid" label="NSAID får ges" :value="operationsanmalan.nsaid_display" />
                    <KFormFieldDisplay
                        name="rontgenbilder_till_op"
                        label="Röntgenbilder till op"
                        :value="operationsanmalan.rontgenbilder_till_op_display?.displayName"
                    />
                    <KFormFieldDisplay
                        name="datum_rontgenbilder_till_op"
                        label="Datum för röntgenbilder till op"
                        :value="operationsanmalan.datum_rontgenbilder_till_op"
                    />
                    <KFormFieldDisplay
                        name="var_ar_rontgen_tagen"
                        label="Var är röntgen tagen"
                        :value="operationsanmalan.var_ar_rontgen_tagen"
                    />
                    <KFormFieldDisplay
                        name="ny_rontgen_infor_op"
                        label="Ny röntgen inför op"
                        :value="operationsanmalan.ny_rontgen_infor_op_display?.displayName"
                    />
                    <KFormFieldDisplay
                        name="blodgruppering"
                        label="Blodgruppering"
                        :value="operationsanmalan.blodgruppering_display"
                    />
                    <KFormFieldDisplay name="bastest" label="Bastest" :value="operationsanmalan.bastest_display" />

                    <KFormFieldDisplay
                        name="info_till_opplaneringen"
                        label="Info till operationskoordinering"
                        class="span-two"
                        :value="operationsanmalan.info_till_opplaneringen"
                    />

                    <KFormFieldDisplay
                        name="info_till_koordinering_och_operation"
                        label="Info till operationskoordinator och operation"
                        class="span-two"
                        :value="operationsanmalan.info_till_koordinering_och_operation"
                    />
                </div>
            </KSection>

            <KSection name="postoperativa_atgarder" class="postoperativa_atgarder" heading="Postoperativa åtgärder">
                <div class="form-content">
                    <KFormFieldDisplay
                        name="hjalpmedel"
                        label="Hjälpmedel"
                        :value="operationsanmalan.hjalpmedel_display"
                        content-direction="vertical"
                        #default="{ value }"
                    >
                        <span v-for="item in value" :key="item.id">
                            {{ item.displayName }}
                        </span>
                    </KFormFieldDisplay>

                    <KFormFieldDisplay
                        name="hjalpmedel_kommentar"
                        label="Hjälpmedel kommentar"
                        class="span-two"
                        :value="operationsanmalan.hjalpmedel_kommentar"
                    />
                </div>
            </KSection>
        </template>
        <template #actions>
            <ButtonGroup margin="none">
                <Button
                    @click="bokningsPopupVisible = true"
                    :disabled="
                        !(
                            [
                                'Klar för operationsbokning',
                                'Avbokad',
                                'Väntar på preanestesibedömning',
                                'Prioriterad preanestesibedömning',
                                'Preanestesibedömning genomförd',
                                'Preanestesibedömning prio genomförd',
                                'Bokad',
                            ].includes(operationsanmalan.status) && can({ action: 'boka', subject: 'anmalan' })
                        )
                    "
                >
                    <span v-if="operationsanmalan.status === 'Bokad'">Redigera bokning</span>
                    <span v-else>Boka operation</span>
                </Button>
                <Button
                    @click="redigeraOperationsanmalan()"
                    :disabled="
                        !(
                            [
                                'Att hantera',
                                'Väntar på preanestesibedömning',
                                'Prioriterad preanestesibedömning',
                                'Väntar på viktnedgång',
                                'Väntar på rökstopp',
                                'Väntar på prover/undersökning',
                                'Offertförfrågan skickad',
                                'Preanestesibedömning genomförd',
                                'Preanestesibedömning prio genomförd',
                                'Klar för operationsbokning',
                                'Bokad',
                                'Avbokad',
                                'Patientvald väntan',
                                'Medicinsk väntan',
                                'Administrativ väntan',
                                'Pågående',
                                'Väntar på hälsodeklaration',
                                'Offertförfrågan ej skickad',
                                'Betalningsförbindelse skickad',
                            ].includes(operationsanmalan.status) && can({ action: 'update', subject: 'anmalan' })
                        )
                    "
                >
                    Redigera operationsanmälan
                </Button>
                <Button
                    @click="avbokningsPopupVisible = true"
                    :disabled="
                        !(['Bokad'].includes(operationsanmalan.status) && can({ action: 'avboka', subject: 'anmalan' }))
                    "
                    variant="alert"
                >
                    Avboka och Stryk
                </Button>
                <Button class="print-button" size="secondary" @click="print">Skriv ut</Button>
                <Button @click="closeTab()" variant="contour" size="secondary">Avbryt</Button>
            </ButtonGroup>

            <ModalContent
                v-if="bokningsPopupVisible"
                title="Redigera bokning"
                :showCloseButton="true"
                @close="bokningsPopupVisible = false"
            >
                <BokaOperation @closePopup="bokningsPopupVisible = false" :value="operationsanmalan" />
            </ModalContent>

            <ModalContent
                v-if="avbokningsPopupVisible"
                title="Avboka eller stryk"
                :showCloseButton="true"
                @close="avbokningsPopupVisible = false"
            >
                <AvbokaOperation @close="avbokningsPopupVisible = false" :value="operationsanmalan" />
            </ModalContent>
        </template>
    </KFormDisplay>
</template>

<script>
    import KFormDisplay from "@/components/forms/displays/FormDisplay/KFormDisplay.vue";
    import KFormFieldDisplay from "@/components/forms/displays/FormFieldDisplay/KFormFieldDisplay.vue";
    import { replaceSeparator } from "@/components/forms/inputs/Number/numberUtils";
    import Status from "@/tabs/Operation/Status.vue";
    import AvbokaOperation from "./AvbokaOperation.vue";
    import BaseTab from "@/tabs/mixins/BaseTab.js";
    import BokaOperation from "@/tabs/Operation/BokaOperation.vue";
    import Button from "@/components/Button.vue";
    import ButtonGroup from "@/components/ButtonGroup.vue";
    import DialogAktivPatient from "@/tabs/Operation/DialogAktivPatient.vue";
    import AnmalanInfoBar from "@/tabs/Operation/AnmalanInfoBar.vue";
    import NivaFranTill from "@/tabs/Operation/NivaFranTill.vue";
    import KlinikenPopup from "@/components/Popup/KlinikenPopup.vue";
    import ModalContent from "@/components/generic/ModalContent.vue";
    import Operationsanmalan from "./Operationsanmalan.vue";
    import tabIcon from "@/assets/bed_icon.svg";
    import { fetchObj } from "./utils";
    import { anmalanStatusIcons, calculateAntalNivaer, isNonEmptyObject } from "@/tabs/Operation/utilsTs";
    import { mapActions, mapGetters } from "vuex";
    import emitter from "tiny-emitter/instance";
    import { flashWarning, openDialog } from "@/utils";
    import { getConfig, klinikenApi } from "@/api";
    import KSection from "@/components/generic/KSection.vue";
    import {
        CONFIG_PROVIDE_NAME,
        ConfigModuleName,
        OperationConfigModuleName,
    } from "@/store/modules/types/configModuleTypes";
    import KGroup from "@/components/forms/groups/Group/KGroup.vue";
    import { provide } from "vue";
    import KText from "@/components/forms/inputs/Text/KText.vue";
    import { getResursWithStatus } from "@/components/forms/reusables/resurserHelper";
    import { printInIframe } from "@/utils/printWindow";
    import moment from "moment";

    export default {
        extends: BaseTab,
        name: "Operationsinformation",
        icon: tabIcon,
        tabName: "Operationsinformation",
        patientBound: true,
        props: {
            parameters: {
                type: Object,
                required: false,
            },
            tabId: Number,
        },
        components: {
            KText,
            Status,
            KFormFieldDisplay,
            KFormDisplay,
            KGroup,
            BokaOperation,
            ModalContent,
            Button,
            ButtonGroup,
            DialogAktivPatient,
            AnmalanInfoBar,
            AvbokaOperation,
            KlinikenPopup,
            Operationsanmalan,
            KSection,
            NivaFranTill,
        },
        setup() {
            provide(CONFIG_PROVIDE_NAME, {
                moduleName: ConfigModuleName.Operation,
                subModuleName: OperationConfigModuleName.Anmalan,
            });
        },
        data() {
            return {
                operationsanmalan: {},
                bokningsPopupVisible: false,
                avbokningsPopupVisible: false,
                diabetes_lakemedelsform: null,
                anmalanStatusIcons,
            };
        },

        computed: {
            ...mapGetters("operation/operationsanmalan", ["operationsanmalningar", "getAlreadyBooked"]),
            ...mapGetters("ability", ["can"]),
        },

        methods: {
            ...mapActions("operation/operationsanmalan", [
                "bokaOpAnmalan",
                "avbokaOperationAnmalan",
                "resetOverbokning",
            ]),
            isNonEmptyObject,
            calculateAntalNivaer: (nivaList) => calculateAntalNivaer(nivaList),
            replaceSeparator,
            async print() {
                if (
                    !this.can({
                        action: "read",
                        subject: "dagsoversikt",
                    })
                ) {
                    return;
                }

                try {
                    await printInIframe({
                        url: "/operation/anmalan/utskrift/",
                        items: [this.operationsanmalan],
                        logName: "Operationsinformation",
                        contentElement: this.$refs.formDisplay.$el,
                        patientInfo: this.operationsanmalan?.patient_display,
                        title: `Operationsinformation ${
                            this.operationsanmalan?.patient_display?.personId_formatted || ""
                        } ${moment().format("YYYY-MM-DD HH:mm")}`,
                        fieldDisplayLayout: "columns",
                    });
                } catch (_) {
                    openDialog("Det gick inte att skriva ut.", "error");
                }
            },
            bmi() {
                if (this.operationsanmalan.langd && this.operationsanmalan.vikt) {
                    return Number.parseFloat(
                        this.operationsanmalan.vikt / Math.pow(this.operationsanmalan.langd / 100, 2)
                    )
                        .toFixed(1)
                        .toString()
                        .replace(".", ",");
                }

                return undefined;
            },
            async redigeraOperationsanmalan() {
                await this.$store.dispatch("operation/operationsanmalan/openOpAnmalan", {
                    component: Operationsanmalan,
                    id: this.operationsanmalan.id,
                    patient: this.operationsanmalan.patient,
                    mode: "opcoordinator",
                });
            },
            closeTab() {
                this.$store.dispatch("tabs/closeTab", this.tabId);
            },

            async fetchDiabetesBehandlingForm() {
                const id = this.operationsanmalan.diabetes_lakemedelsform;

                if (!id) {
                    return;
                }

                try {
                    const response = await klinikenApi.get(
                        `/operation/kodverk/diabetesbehandlingsform/${id}/`,
                        getConfig()
                    );

                    const namn = response.data?.namn;

                    if (namn) {
                        this.diabetes_lakemedelsform = namn;
                    }
                } catch (error) {
                    throw new Error(error);
                }
            },
            async onOperationsanmalanUppdaterad(operationsanmalan) {
                this.operationsanmalan = {
                    ...this.operationsanmalan,
                    ...operationsanmalan,
                };
            },
            getResursWithStatus,
        },
        async created() {
            const { operationsanmalan_id } = this.parameters;
            this.operationsanmalan = await fetchObj({
                url: `operation/anmalan/${operationsanmalan_id}`,
                tabbnamn: "Operationsinformation",
            });

            if (this.operationsanmalan) {
                try {
                    await this.fetchDiabetesBehandlingForm();
                } catch (error) {
                    flashWarning("Det gick inte att hämta diabetesbehandlingsform");
                }
            }
        },
        mounted() {
            emitter.on("operationsanmalan-uppdaterad", this.onOperationsanmalanUppdaterad);
            emitter.on("operationsanmalan-bokad", this.onOperationsanmalanUppdaterad);
            emitter.on("operationsanmalan-avbokad", this.onOperationsanmalanUppdaterad);
        },
        beforeDestroy() {
            emitter.off("operationsanmalan-uppdaterad", this.onOperationsanmalanUppdaterad);
            emitter.off("operationsanmalan-avbokad", this.onOperationsanmalanUppdaterad);
            emitter.off("operationsanmalan-bokad", this.onOperationsanmalanUppdaterad);
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/style/variables";
    @import "@/style/container";
    @import "@/style/components";

    .operationsinformation {
        width: $content-max-width;
        max-width: 100%;
        container-type: inline-size;

        .resurser {
            .content {
                display: grid;
                grid-template-columns: auto 1fr;
                grid-auto-flow: row;
                grid-column-gap: 1.5rem;

                .resurs {
                    display: grid;
                    grid-template-columns: subgrid;
                    grid-column: 1 / -1;

                    .antal {
                        font-size: 0.9rem;
                    }
                }
            }
        }

        .status {
            display: flex;
            align-items: center;
            &:not(:first-child) {
                justify-content: end;
            }
            ::v-deep {
                > span {
                    white-space: nowrap;
                    > * {
                        white-space: normal;
                    }
                }
            }
        }
        ::v-deep(.modal-content .body) {
            padding: 1.25rem 2rem;
        }
    }
</style>
